import { useField } from 'formik';
import React from 'react';
import { SelectSection } from './SelectSection';
import { Props } from './SelectSection';

interface FormProps {
    name: string;
}

export const FormSelectSection: React.FC<
    FormProps & Omit<Props, 'value' | 'onChange'>
> = ({ name, ...props }) => {
    const [field, , helpers] = useField(name);
    return (
        <SelectSection
            {...props}
            value={field.value}
            onChange={helpers.setValue}
        />
    );
};
